var map = {
	"./aaa.svg": "749b",
	"./close.svg": "8b1b",
	"./dessert.svg": "9e12",
	"./facebook.svg": "8485",
	"./facebook2.svg": "594c",
	"./hamburger-menu.svg": "b602",
	"./icon1.svg": "3383",
	"./instagram.svg": "bd6c",
	"./noodle.svg": "5f2d",
	"./pasta.svg": "7317",
	"./salad.svg": "41b7",
	"./vegetables.svg": "bac2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";